<template>
  <div class="ligneTitre">
    <slot />
    <div class="righticons">
      <img src="/assets/icons/liste.png" @click="listMode" />
      <img src="/assets/icons/mosaic.png" @click="mosaicMode" />
      <slot name="reload" />
    </div>
  </div>
</template>

<script>
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
export default {
  name: "LigneTitre",
  props: {
    patternName: {
      type: String,
      default: ""
    }
  },
  methods: {
    listMode() {
      idyuJsonRpc("setListType", 0);
      this.$store.state.user.listType = 0;
    },

    mosaicMode() {
      idyuJsonRpc("setListType", 1);
      this.$store.state.user.listType = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.ligneTitre {
  border-bottom: #ddd 1px solid;
  h2 {
    font-size: 18px;
    margin-top: 5px;
    margin-bottom: 5px;

    a {
      color: $theme_color;
    }
  }

  position: relative;
  padding-left: 5px;
  padding-right: 5px;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  grid-gap: 10px;
  align-items: center;
}

.righticons {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
  align-items: center;
  position: absolute;
  right: 10px;
  img {
    cursor: pointer;
  }
}
</style>
